function IsTBRIClient(data) {
  return data.name.toUpperCase() === "TBRI" || data.name.toUpperCase() === "TBR";
}

export default IsTBRIClient;
